<template>
  <div class="timezone-selector">
    <v-autocomplete
      id="timezone-selector-time-zone"
      ref="selectTimezone"
      v-model="timezone"
      v-model:search="searchTimezone"
      :items="timezones"
      placeholder="Select Time Zone"
      clearable
      :multiple="false"
      hide-details
      :hide-selected="hideSelected"
      :closable-chips="false"
      variant="solo"
      required
      :error-messages="errorMessages"
      density="compact"
      clear-icon="mdi-close"
      color="primary"
      @update:model-value="onTimezoneChange"
    >
    </v-autocomplete>
  </div>
</template>
<script>
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment-timezone';

export default {
  name: 'TimezoneSelector',

  props: {
    modelValue: { type: String, required: false, default: '' },
    errorMessages: { type: Array, required: false },
    hideSelected: { type: Boolean, required: false, default: false }
  },

  emits: ['update:modelValue'],

  data() {
    return {
      timezone: this.modelValue,
      searchTimezone: null,
      timezones: [],
      allTimezones: []
    };
  },

  watch: {
    modelValue(val) {
      this.timezone = val;
    },
    searchTimezone(val) {
      let localVal = val;
      localVal = val ? val.toLowerCase() : '';
      this.timezones = this.allTimezones.filter(
        (t) => t.title.toLowerCase().indexOf(localVal) > -1
      );
    }
  },
  async mounted() {
    this.setTimezones();
  },
  methods: {
    setTimezones() {
      const timezoneNames = moment.tz.names();
      timezoneNames.forEach((name) => {
        const text = `${name.replace(/_/g, ' ')} (UTC${moment.tz(name).format('Z')})`;
        this.timezones.push({ value: name, title: text });
      });
      this.allTimezones = cloneDeep(this.timezones);
    },
    onTimezoneChange(newTimezone) {
      this.$emit('update:modelValue', newTimezone);
    }
  }
};
</script>
